import styles from "./Card.module.scss";
import Image from "@components/Image";
import Button from "@components/Button";
import Link from "@components/Link";
import cx from "classnames";
import gstyles from "@gstyles/index";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
import _ from "lodash";

const View = ({
  image = {},
  title = "",
  description = "",
  phone = "",
  website = "",
  direction = "",
  distance = "",
  button,
  footer,
  className,
  style,
}: any) => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <div className={cx(styles.card, className)} style={style}>
      <div className={styles.img}>
        <Image
          scale="1.15"
          loading="eager"
          wrapperProps={{ className: cx(styles.img) }}
          src={_.get(image, "src")}
          alt={_.get(image, "alt")}
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles.box}>
        {!!title && (
          <div className={cx("ama-content", styles.title)}>{title}</div>
        )}
        <div className={styles.descBox}>
          <div
            className={cx("ama-content", styles.description)}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></div>
          <div className={styles.groupInfo}>
            {!!phone && (
              <Link href={`tel:${phone}`}>
                <div className={styles.phone}>
                  {gstyles.icons({ name: "phone-yellow", size: 24 })}
                  {phone}
                </div>
              </Link>
            )}
            {!!website && (
              <Link href={website} target="_blank" rel="nofollow">
                <div className={styles.site}>
                  {gstyles.icons({ name: "link-yellow", size: 24 })}
                  Website
                </div>
              </Link>
            )}
            {!!distance && (
              <Link href={direction} target="_blank" rel="nofollow">
                <div className={styles.location}>
                  {gstyles.icons({ name: "map-marker-yellow", size: 24 })}
                  {i18n.t("Discover.BlockLocation.distanceAmanaki")}
                  {distance}
                </div>
              </Link>
            )}
            {!!button ? (
              button
            ) : (
              <div className={styles.map}>
                <Button
                  onClick={() => {
                    router.open(direction);
                  }}
                  type="icon"
                  dark
                  className={cx("uppercase button", styles.button)}
                  label={i18n.t("Discover.BlockLocation.checkMap")}
                  suffix="shape-arrow"
                />
              </div>
            )}
            {!!footer && footer}
          </div>
        </div>
      </div>
    </div>
  );
};
export default View;
